import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const CompleteReview = () => {
  return (
    <div>
      <PageTitle title='Complete Review' role='Reviewer' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='After logging in as a role with Reviewer privileges, any events waiting on the Reviewer to review will be listed under the "My Reviews" tab. If no tab is present, then no reviews are currently assigned. Once clicking on the "My Reviews" tab, a table listing all the assigned events will be populated. Click on the event to review to view the Event Summary page.' />
      <ParaImageDialog src='/tutorial_image/complete-review-1.png' />

      <ParaTitle paraTitle='Completing Review' />
      <Paragraph paragraph='On the Event Summary page, the Reviewer has the ability to review the entire event. Comments, files, and linked events are also available to the Reviewer. Once the Reviewer is ready to close the review, he or she will click on the "Actions" drop down tab and select "Close Review".' />
      <ParaImageDialog src='/tutorial_image/complete-review-2.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'Requesting Approval', link: '/risk-manager/requesting-approval' },
          next: { name: 'Approve Events', link: '/approver/approve-events' }
        }}
      />
    </div>
  );
};

export default CompleteReview;
